import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';

import LandAssemblyFeatureItem from './LandAssemblyFeatureItem';
import SimpleHeading from '../common/SimpleHeading';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {

};

const defaultProps = {

};

function LandAssemblyFeatureList () {
    const classes = useStyles();
    const features = useSelector(state => state.landAssembly.features);
    const layer = useSelector(state => state.layers.layers.find(l => l.id === state.landAssembly.layerId));

    return (<>
        <SimpleHeading label="2. SELECT PARCELS TO ASSEMBLE" tooltip="Select parcels on the map to form a land assembly, click an already selected parcel to deselect"/>
        {
            features.length === 0 ?
                <Alert severity={'info'}>
                    {/* <AlertTitle> */}
                        Click parcels on the map to add to land assembly
                    {/* </AlertTitle> */}
                </Alert> :
                features.map((feature, idx) => <LandAssemblyFeatureItem key={idx} layer={layer} feature={feature} />)
        }
    </>);
}

LandAssemblyFeatureList.propTypes = propTypes;
LandAssemblyFeatureList.defaultProps = defaultProps;

const style = theme => ({
    root: {
        padding: theme.constants.spacing.xl,
        '&> *:not(:last-child)':{
            marginBottom: theme.constants.verticalMargin
        }
    }
});

export default LandAssemblyFeatureList;